var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      ref: "weekModelDialog",
      attrs: { height: "90vh", width: "700px" },
      model: {
        value: _vm.weekModal,
        callback: function ($$v) {
          _vm.weekModal = $$v
        },
        expression: "weekModal",
      },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-layout",
            { attrs: { column: "", "align-center": "" } },
            [
              _c(
                "v-card",
                { ref: "form", attrs: { width: "100%" } },
                [
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "primary--text",
                                attrs: { align: "center" },
                              },
                              [
                                !_vm.saveMode
                                  ? _c("h1", [
                                      _vm._v(_vm._s(_vm.$t("newWeeklyModel"))),
                                    ])
                                  : _c("h1", [
                                      _vm._v(_vm._s(_vm.$t("editWeeklyModel"))),
                                    ]),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { "justify-space-between": "", row: "" },
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { grow: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  disabled: _vm.WeekModel.locked,
                                  counter: 50,
                                  label: _vm.$t("weeklyModelName"),
                                  rules: _vm.nameRules,
                                  required: "",
                                },
                                on: { change: _vm.calculateWeekTime },
                                model: {
                                  value: _vm.WeekModel.weekModelName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.WeekModel,
                                      "weekModelName",
                                      $$v
                                    )
                                  },
                                  expression: "WeekModel.weekModelName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { staticClass: "ml-3", attrs: { shrink: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  disabled: _vm.WeekModel.locked,
                                  label: _vm.$t("weeklyWorkTime"),
                                  "prepend-icon": "mdi-clock-outline",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.WeekModel.weeklyTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.WeekModel, "weeklyTime", $$v)
                                  },
                                  expression: "WeekModel.weeklyTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { "justify-space-between": "", column: "" },
                        },
                        [
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    disabled: _vm.WeekModel.locked,
                                    items: _vm.weekDailyModelList,
                                    label: _vm.$t("monday"),
                                    "append-icon": "mdi-close",
                                    rules: _vm.selecterRules,
                                    chips: "",
                                  },
                                  on: {
                                    "click:append": function ($event) {
                                      return _vm.clickHandler("MondayId")
                                    },
                                    change: _vm.calculateWeekTime,
                                  },
                                  model: {
                                    value: _vm.WeekModel.MondayId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.WeekModel, "MondayId", $$v)
                                    },
                                    expression: "WeekModel.MondayId",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.weekDailyModelList.dailyModelName
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    disabled: _vm.WeekModel.locked,
                                    items: _vm.weekDailyModelList,
                                    label: _vm.$t("tuesday"),
                                    "append-icon": "mdi-close",
                                    rules: _vm.selecterRules,
                                    chips: "",
                                  },
                                  on: {
                                    "click:append": function ($event) {
                                      return _vm.clickHandler("TuesdayId")
                                    },
                                    change: _vm.calculateWeekTime,
                                  },
                                  model: {
                                    value: _vm.WeekModel.TuesdayId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.WeekModel, "TuesdayId", $$v)
                                    },
                                    expression: "WeekModel.TuesdayId",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.weekDailyModelList.dailyModelName
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            [
                              _c("v-select", {
                                attrs: {
                                  disabled: _vm.WeekModel.locked,
                                  items: _vm.weekDailyModelList,
                                  label: _vm.$t("wednesday"),
                                  "append-icon": "mdi-close",
                                  rules: _vm.selecterRules,
                                  chips: "",
                                },
                                on: {
                                  "click:append": function ($event) {
                                    return _vm.clickHandler("WednesdayId")
                                  },
                                  change: _vm.calculateWeekTime,
                                },
                                model: {
                                  value: _vm.WeekModel.WednesdayId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.WeekModel, "WednesdayId", $$v)
                                  },
                                  expression: "WeekModel.WednesdayId",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    disabled: _vm.WeekModel.locked,
                                    items: _vm.weekDailyModelList,
                                    label: _vm.$t("thursday"),
                                    "append-icon": "mdi-close",
                                    rules: _vm.selecterRules,
                                    chips: "",
                                  },
                                  on: {
                                    "click:append": function ($event) {
                                      return _vm.clickHandler("ThursdayId")
                                    },
                                    change: _vm.calculateWeekTime,
                                  },
                                  model: {
                                    value: _vm.WeekModel.ThursdayId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.WeekModel, "ThursdayId", $$v)
                                    },
                                    expression: "WeekModel.ThursdayId",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.weekDailyModelList.dailyModelName
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    items: _vm.weekDailyModelList,
                                    disabled: _vm.WeekModel.locked,
                                    label: _vm.$t("friday"),
                                    "append-icon": "mdi-close",
                                    rules: _vm.selecterRules,
                                    chips: "",
                                  },
                                  on: {
                                    "click:append": function ($event) {
                                      return _vm.clickHandler("FridayId")
                                    },
                                    change: _vm.calculateWeekTime,
                                  },
                                  model: {
                                    value: _vm.WeekModel.FridayId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.WeekModel, "FridayId", $$v)
                                    },
                                    expression: "WeekModel.FridayId",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.weekDailyModelList.dailyModelName
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    items: _vm.weekDailyModelList,
                                    disabled: _vm.WeekModel.locked,
                                    label: _vm.$t("saturday"),
                                    "append-icon": "mdi-close",
                                    rules: _vm.selecterRules,
                                    chips: "",
                                  },
                                  on: {
                                    "click:append": function ($event) {
                                      return _vm.clickHandler("SaturdayId")
                                    },
                                    change: _vm.calculateWeekTime,
                                  },
                                  model: {
                                    value: _vm.WeekModel.SaturdayId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.WeekModel, "SaturdayId", $$v)
                                    },
                                    expression: "WeekModel.SaturdayId",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.weekDailyModelList.dailyModelName
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    items: _vm.weekDailyModelList,
                                    disabled: _vm.WeekModel.locked,
                                    label: _vm.$t("sunday"),
                                    "append-icon": "mdi-close",
                                    rules: _vm.selecterRules,
                                    chips: "",
                                  },
                                  on: {
                                    "click:append": function ($event) {
                                      return _vm.clickHandler("SundayId")
                                    },
                                    change: _vm.calculateWeekTime,
                                  },
                                  model: {
                                    value: _vm.WeekModel.SundayId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.WeekModel, "SundayId", $$v)
                                    },
                                    expression: "WeekModel.SundayId",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.weekDailyModelList.dailyModelName
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  disabled: _vm.WeekModel.locked,
                                  label: _vm.$t("emptyTimeAccountOnMonthStart"),
                                },
                                model: {
                                  value: _vm.WeekModel.emptyOnMonthStart,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.WeekModel,
                                      "emptyOnMonthStart",
                                      $$v
                                    )
                                  },
                                  expression: "WeekModel.emptyOnMonthStart",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  disabled: _vm.WeekModel.locked,
                                  label: _vm.$t("deductBreakTimes"),
                                },
                                model: {
                                  value: _vm.WeekModel.deductBreakTimes,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.WeekModel,
                                      "deductBreakTimes",
                                      $$v
                                    )
                                  },
                                  expression: "WeekModel.deductBreakTimes",
                                },
                              }),
                              _vm._l(_vm.deductBreaks, function (item, i) {
                                return _c(
                                  "v-row",
                                  { key: i, attrs: { "no-gutters": "" } },
                                  [
                                    _vm.WeekModel.deductBreakTimes
                                      ? _c("v-text-field", {
                                          staticClass: "pr-2",
                                          attrs: {
                                            rules: [_vm.rules.time.regex],
                                            label: _vm.$t("deductTimeFrom"),
                                            disabled: _vm.WeekModel.locked,
                                            "append-icon": "mdi-close",
                                          },
                                          on: {
                                            "click:append": function ($event) {
                                              item.deductFrom = ""
                                            },
                                          },
                                          model: {
                                            value: item.deductFrom,
                                            callback: function ($$v) {
                                              _vm.$set(item, "deductFrom", $$v)
                                            },
                                            expression: "item.deductFrom",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.WeekModel.deductBreakTimes
                                      ? _c("v-text-field", {
                                          staticClass: "pl-2",
                                          attrs: {
                                            rules: [_vm.rules.time.regex],
                                            label: _vm.$t("break"),
                                            disabled: _vm.WeekModel.locked,
                                            "append-icon": "mdi-close",
                                          },
                                          on: {
                                            "click:append": function ($event) {
                                              item.deductBreak = ""
                                            },
                                          },
                                          model: {
                                            value: item.deductBreak,
                                            callback: function ($$v) {
                                              _vm.$set(item, "deductBreak", $$v)
                                            },
                                            expression: "item.deductBreak",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "pr-4",
                                    attrs: {
                                      disabled: _vm.WeekModel.locked,
                                      label: _vm.$t("cutStartTime"),
                                    },
                                    model: {
                                      value: _vm.WeekModel.cutStartTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel,
                                          "cutStartTime",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.cutStartTime",
                                    },
                                  }),
                                  _c("v-checkbox", {
                                    attrs: {
                                      disabled: _vm.WeekModel.locked,
                                      label: _vm.$t("cutEndTime"),
                                    },
                                    model: {
                                      value: _vm.WeekModel.cutEndTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.WeekModel,
                                          "cutEndTime",
                                          $$v
                                        )
                                      },
                                      expression: "WeekModel.cutEndTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-textarea", {
                        staticClass: "pb-2",
                        attrs: {
                          name: "input-7-1",
                          disabled: _vm.WeekModel.locked,
                          label: _vm.$t("remark"),
                          counter: 254,
                          rules: _vm.remarkRules,
                        },
                        model: {
                          value: _vm.WeekModel.weekModelText,
                          callback: function ($$v) {
                            _vm.$set(_vm.WeekModel, "weekModelText", $$v)
                          },
                          expression: "WeekModel.weekModelText",
                        },
                      }),
                      _c(
                        "v-layout",
                        { attrs: { "align-center": "", "justify-center": "" } },
                        [
                          !_vm.saveMode
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "buttonHoverOpacity",
                                  attrs: { color: "primary" },
                                  on: { click: _vm.addWeekModel },
                                },
                                [_vm._v(_vm._s(_vm.$t("addWeeklyModel")))]
                              )
                            : _c(
                                "v-btn",
                                {
                                  staticClass: "buttonHoverOpacity",
                                  attrs: { color: "primary" },
                                  on: { click: _vm.saveWeekModel },
                                },
                                [_vm._v(_vm._s(_vm.$t("saveWeeklyModel")))]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }